@if (props.prepend || props.append) {
  <div class="input-group mb-3">
    @if (props.prepend) {
      <span class="input-group-text">{{ props.prepend }}</span>
    }
    <ng-template [ngTemplateOutlet]="input"></ng-template>
    @if (props.append) {
      <span class="input-group-text">{{ props.append }}</span>
    }
  </div>
} @else {
  @if (props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [value]="props.template"
      (click)="onClick($event)"
    />
  } @else {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [class.text-end]="props.textRight"
      (keyup.enter)="keyUpEnter($event)"
      (keyup.backspace)="keyUpBackspace($event)"
      (focus)="onFocus()"
      (click)="onClick($event)"
    />
  }
}

<ng-template #input>
  @if (props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [value]="props.template"
      (click)="onClick($event)"
    />
  }
  @if (!props.template) {
    <input
      class="form-control {{ props.cssClass }}"
      [type]="type"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [class.is-valid]="valid"
      [class.is-invalid]="invalid"
      [class.text-end]="props.textRight"
      (keyup.enter)="keyUpEnter($event)"
      (keyup.backspace)="keyUpBackspace($event)"
      (focus)="onFocus()"
      (click)="onClick($event)"
    />
  }
</ng-template>
